import React from 'react'
import LawnexData from '../../assest/data/LawnexData';

function LawnexFitur() {
  return (
    <>
    <div className='our-works' data-aos='fade-up'>
        <div className='ourWorkHolder'>
      <div className='OurWorkCard'>
        <LawnexData/>
      </div>
      </div>
    </div>
    </>
  )
}

export default LawnexFitur